import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Avatar, Box, Button, ListItemIcon, Menu, MenuItem, Stack, Typography } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import brandLockup from '../../../asset/logo/lockup-horizontal-color.svg';
import { BORDER, ERROR_TEXT, INTER, NAVY, POPPINS, SLATE, SURFACE_MUTED } from '../teacherStyles';

interface TeacherGlobalHeaderProps {
    onNotice: (message: string) => void;
}

export default function TeacherGlobalHeader({ onNotice }: TeacherGlobalHeaderProps) {
    const history = useHistory();
    const [profileAnchor, setProfileAnchor] = React.useState<HTMLElement | null>(null);

    return (
        <Box
            component="header"
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 5,
                minHeight: 72,
                px: { xs: 2, sm: 3, lg: 4 },
                display: 'flex',
                alignItems: 'center',
                backgroundColor: 'rgba(255,255,255,0.96)',
                borderBottom: `1px solid ${BORDER}`,
                backdropFilter: 'blur(10px)',
            }}
        >
            <Button onClick={() => history.push('/mockup/teacher')} sx={{ p: 0, minWidth: 0, textTransform: 'none' }}>
                <Stack direction="row" alignItems="center" spacing={1.4}>
                    <Box component="img" src={brandLockup} alt="VerbaSchola" sx={{ height: { xs: 22, sm: 25 }, width: 'auto', display: 'block' }} />
                    <Box sx={{ display: { xs: 'none', sm: 'block' }, width: '1px', height: 20, backgroundColor: BORDER }} />
                    <Typography sx={{ display: { xs: 'none', sm: 'block' }, fontFamily: INTER, fontWeight: 600, fontSize: 11, color: SLATE, letterSpacing: '0.08em', textTransform: 'uppercase' }}>Teacher</Typography>
                </Stack>
            </Button>

            <Box sx={{ ml: 'auto' }}>
                <Button
                    onClick={event => setProfileAnchor(event.currentTarget)}
                    aria-haspopup="menu"
                    aria-expanded={Boolean(profileAnchor)}
                    sx={{ minWidth: 0, p: 0.75, borderRadius: '12px', textTransform: 'none', '&:hover': { backgroundColor: SURFACE_MUTED } }}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Avatar sx={{ width: 38, height: 38, backgroundColor: NAVY, fontFamily: POPPINS, fontSize: 13 }}>EF</Avatar>
                        <Typography sx={{ display: { xs: 'none', lg: 'block' }, fontFamily: INTER, fontWeight: 700, fontSize: 12.5, color: NAVY, lineHeight: 1.15, textAlign: 'left' }}>Emily Foster</Typography>
                        <KeyboardArrowDownRoundedIcon sx={{ display: { xs: 'none', sm: 'block' }, ml: 0.25, color: SLATE, fontSize: 19 }} />
                    </Stack>
                </Button>
                <Menu
                    anchorEl={profileAnchor}
                    open={Boolean(profileAnchor)}
                    onClose={() => setProfileAnchor(null)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{ sx: { minWidth: 190, mt: 0.75, border: `1px solid ${BORDER}`, borderRadius: '13px', boxShadow: '0 10px 30px rgba(22, 58, 99, 0.12)' } }}
                >
                    {[
                        { label: 'Profile', icon: PersonOutlineRoundedIcon },
                        { label: 'Settings', icon: SettingsOutlinedIcon },
                        { label: 'Help & support', icon: HelpOutlineRoundedIcon },
                        { label: 'Sign out', icon: LogoutRoundedIcon },
                    ].map(item => (
                        <MenuItem
                            key={item.label}
                            onClick={() => {
                                setProfileAnchor(null);
                                onNotice(`${item.label} is not connected in this static demo.`);
                            }}
                            sx={{ minHeight: 42, fontFamily: INTER, fontSize: 12.5, color: item.label === 'Sign out' ? ERROR_TEXT : NAVY }}
                        >
                            <ListItemIcon sx={{ minWidth: '32px !important', color: item.label === 'Sign out' ? ERROR_TEXT : SLATE }}><item.icon sx={{ fontSize: 19 }} /></ListItemIcon>
                            {item.label}
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
        </Box>
    );
}
